import fetchRetry from '../universal/fetch-retry';

export const NOTIFICATION_LIMIT = 3;

export const getNotificationsUrl = (locale, market, browserName) => {
  const url = new URL(process.env.apiUrl);
  url.pathname = '/v1/notifications';
  url.searchParams.set('language', locale);
  url.searchParams.set('limit', NOTIFICATION_LIMIT);

  if (market) {
    url.searchParams.set('market', market);
  }

  if (browserName) {
    url.searchParams.set('browser', browserName);
  }

  return url.toString();
};

export const getNotifications = async (locale, market, browserName) => {
  const response = await fetchRetry(getNotificationsUrl(locale, market, browserName));
  return response.json();
};
